/**
 * SplashScreen Component
 * 
 * Simple splash screen showing YAPN logo with dashboard theme.
 */

import React, { useEffect, useState } from 'react';
import yapnLogo from '../../assets/yapn-logo.png';

/**
 * SplashScreen component
 * 
 * @param {object} props - Component props
 * @param {Function} props.onComplete - Callback when animation completes
 */
const SplashScreen = ({ onComplete }) => {
  const [fadeOut, setFadeOut] = useState(false);

  useEffect(() => {
    // Start fade out after 1.5 seconds (shorter duration)
    const timer = setTimeout(() => {
      setFadeOut(true);
    }, 1500);

    // Complete after fade out animation (2 seconds total)
    const completeTimer = setTimeout(() => {
      onComplete();
    }, 2000);

    return () => {
      clearTimeout(timer);
      clearTimeout(completeTimer);
    };
  }, [onComplete]);

  return (
    <div
      className={`
        fixed inset-0 bg-gray-950 z-50 flex items-center justify-center
        transition-opacity duration-500
        ${fadeOut ? 'opacity-0' : 'opacity-100'}
      `}
    >
      <div className="text-center">
        {/* YAPN Logo */}
        <img 
          src={yapnLogo} 
          alt="YAPN" 
          className="h-32 w-auto mx-auto opacity-90"
        />
      </div>
    </div>
  );
};

export default SplashScreen;

